import React, { useState, useEffect } from 'react'
import { useLocation, withRouter } from 'react-router-dom'
import { useFormikContext } from 'formik'

const FormNavigationDots = ({ history }) => {
    const location = useLocation()
    const { errors } = useFormikContext()
    const [activeRoute, setActiveRoute] = useState('')

    useEffect(() => {
        setActiveRoute(location.pathname.split('/').pop())
    }, [location])

    const NavigationRoutes = [
        { url: 'client', display: 'Personal & Income Data' },
        // { url: 'occupation', display: 'Occupation' },
        // { url: 'income', display: 'Income' },
        { url: 'coverage', display: 'Existing Coverage' },
        { url: 'assets', display: 'Other Insured Assets' },
        { url: 'protections', display: 'New Coverage' },
    ]

    const NavClassName = (section, errors) => {
        let rtnClass = 'clickable'

        if (section === activeRoute) {
            rtnClass = `${rtnClass} active`
        }

        if (errors && errors[section]) {
            rtnClass = `${rtnClass} error`
        }

        return rtnClass
    }

    const TryNavigations = (route) => {
        // turn path like /clients/new/<blah> into /clients/new/<route>
        let urlParts = location.pathname.split('/')
        urlParts.pop()
        urlParts.push(route)
        const newUrl = urlParts.join('/')
        history.push(newUrl)
    }

    return (
        <>
            {NavigationRoutes.map((route) => {
                const { url, display } = route
                return (
                    <li
                        key={url}
                        onClick={() => {
                            TryNavigations(url)
                        }}
                        className={NavClassName(url, errors)}
                    >
                        <span></span>
                        <p>{display}</p>
                    </li>
                )
            })}
        </>
    )
}

export default withRouter(FormNavigationDots)
